<div class="container-sm-fluid pt-3 px-sm-4">
    <dx-tabs
        [items]="tabs"
        [selectedItem]="selectedTab"
        [showNavButtons]="false"
        stylingMode="primary"
        class="mb-2"
        (onItemClick)="onTabClick($event)"
    ></dx-tabs>
</div>

@if (selectedTab?.id === 0) {
    <app-checklist-compliance-score></app-checklist-compliance-score>
} @else if (selectedTab?.id === 1) {
    <app-checklist-condition-score></app-checklist-condition-score>
} @else if (selectedTab?.id === 2) {
    <app-incident-report-score [daysLookBack]="7"></app-incident-report-score>
}@else if (selectedTab?.id === 3) {
    <app-incident-report-score [isObservations]="true" [daysLookBack]="7"></app-incident-report-score>
}